const borderRadiusToPixels = {
    sharp: { default: 0, large: 0, maybePill: 0 },
    soft: { default: 4, large: 8, maybePill: 4 },
    rounded: { default: 16, large: 32, maybePill: 100 },
} as const;

export default borderRadiusToPixels;
